export class SymbolsState {

    private static _instance: SymbolsState;
    private _symbolsSearchIds: number[] = [];
    private _symbolsGridIds: number[] = [];
    private _symbolsDealIds: number[] = [];
    private _openTradeSymbolId: number;
    private _closedTradeSymbolId: number;

    private constructor() {
    }

    public static instance(): SymbolsState {
        return this._instance || (this._instance = new this());
    }

    public set symbolsSearchIds(value: number[]) {
        this._symbolsSearchIds = value;
    }

    public set symbolsGridIds(value: number[]) {
        this._symbolsGridIds = value;
    }

    public set symbolsDealIds(value: number[]) {
        this._symbolsDealIds = value;
    }

    public set openTradeSymbolId(value: number) {
        this._openTradeSymbolId = value;
    }

    public set closedTradeSymbolId(value: number) {
        this._closedTradeSymbolId = value;
    }

    public get additionalSymbolsIds(): number[] {
        const ids: number[] = [...this._symbolsSearchIds, ...this._symbolsGridIds, ...this._symbolsDealIds];
        if (this._openTradeSymbolId) {
            ids.push(this._openTradeSymbolId);
        }
        if (this._closedTradeSymbolId) {
            ids.push(this._closedTradeSymbolId);
        }
        return ids;
    }

    public clear(): void {
        this._symbolsSearchIds = [];
        this._symbolsGridIds = [];
        this._symbolsDealIds = [];
        this._openTradeSymbolId = null;
        this._closedTradeSymbolId = null;
    }
}
